import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { HttpClientModule } from '@angular/common/http';
import { ResetSuccessComponent } from '../reset-success/reset-success.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Observer } from 'rxjs';
import { ResetFailedComponent } from '../reset-failed/reset-failed.component';

@Component({
  selector: 'new-password',
  templateUrl: './new-password.component.html',
  imports: [
    ResetSuccessComponent,
    ResetFailedComponent,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  styleUrls: [
    './new-password.component.css',
    '../../globals.css',
    '../../styleguide.css',
  ],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class NewPasswordComponent implements OnInit {
  isSuccess = false;
  hasError = false;
  token: string | null = null;

  formGroup = new FormGroup({
    passwordFormControl: new FormControl(''),
    confirmPasswordFormControl: new FormControl(''),
  });

  isSubmitted = false;
  isReset = false;
  passwordValidationError: string = '';
  password = '';
  confirmPassword = '';

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.token = params.get('token'); // Extract the token from the query parameters
    });
  }

  validatePassword() {
    this.password = this.formGroup.get('passwordFormControl')?.value!;
    this.confirmPassword = this.formGroup.get(
      'confirmPasswordFormControl'
    )?.value!;
    const passwordFormatRegex = /^(?=.*[\d\W_])[A-Za-z\d\W_]{8,}$/;
    if (!this.password || !this.confirmPassword) {
      this.passwordValidationError = 'Please enter a password.';
    } else if (this.password !== this.confirmPassword) {
      this.passwordValidationError = 'Passwords do not match.';
    } else if (this.password.length < 8) {
      this.passwordValidationError =
        'Password must be at least 8 characters long.';
    } else if (!passwordFormatRegex.test(this.password)) {
      this.passwordValidationError = this.passwordValidationError =
        'Password must include at least 8 characters with at least 1 number or symbol.';
    } else {
      this.passwordValidationError = '';
    }

    if (this.passwordValidationError) {
      return;
    }
  }

  onInputChange() {
    if (this.isSubmitted) {
      this.validatePassword();
    }
  }

  updatePassword(token: string) {
    this.isSubmitted = true;
    this.validatePassword();

    if (this.passwordValidationError) {
      return;
    }

    this.isReset = true;

    this.apiService.updatePassword(token, this.password).subscribe({
      next: (data: any) => {
        console.log('Data:', data);
        this.isSuccess = true;
      },
      error: (error: any) => {
        this.hasError = true;
        console.error('Error:', error);
      },
    } as Observer<any>);
  }

  updateIsClicked(value: boolean) {
    this.router.navigate(['/forgot-password']);
  }
}
